<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id && !miapayWalletHolderId ? actions : []"
    :form="form"
    :onFetchData="onFetchData"
    :title="title || $t('model.withdrawalApplication')"
    resource="withdrawal_applications"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/withdrawal_applications.js';
import _ from 'lodash';

@Component
export default class WithdrawalApplications extends Vue {
  @Prop(String) type;
  @Prop(String) title;
  @Prop(Number) miapayWalletHolderId;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'number_cont',
      'state_eq',
      !this.miapayWalletHolderId && {
        prop: 'wallet_holder_id_eq',
        label: this.$t('plutus_entries.user_or_agent_phone'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/miapay/wallet_holders/read_options', { params: { must_contain_id: this.$route.query.wallet_holder_id_eq } });
              return _.map(data, ({ id, phone }) => ({ value: id, label: phone }));
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/miapay/wallet_holders/read_options', { params: { keyword, must_contain_id: this.$route.query.wallet_holder_id_eq } });
              return _.map(data, ({ id, phone }) => ({ value: id, label: phone }));
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      }
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      {
        key: 'state',
        minWidth: 120,
      },
      type === 'show' && {
        prop: 'wallet_holder.profile_attributes.name',
        label: this.$t('withdrawalApplication.userName'),
      },
      {
        prop: 'wallet_holder',
        label: this.$t('withdrawalApplication.miapayAccountNumber'),
        renderCell: (h, { props: { value } }) => {
          if (value.agent) {
            return <bean-link to={{ name: 'agents.show', params: { id: value.agent.id } }}>{this.$t('model.agent')} {value.phone}</bean-link>
          } else if (value.user) {
            return <bean-link to={{ name: 'users.show', params: { id: value.user.id } }}>{this.$t('model.user')} {value.phone}</bean-link>
          }
        }
      },
      'amount_cents',
      'channel',
      type === 'show' && {
        prop: 'receivable_account.number',
        label: this.$t('withdrawalApplication.paymentAccountNumber'),
      },
      type === 'show' && 'number',
      type === 'show' && 'finished_at',
      type === 'show' && { key: 'reject_reason' },
      type === 'show' && 'auditor',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'reject_reason',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      // {
      //   component: 'routeButton',
      //   props: {
      //     label: this.$t('edit'),
      //     to: { name: 'withdrawal_applications.edit', params: { id: row.id } }
      //   }
      // },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'withdrawal_applications.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
      row.state === 'init' && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.approve'),
          type: 'primary',
          can: 'withdrawal_applications.approve'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/withdrawal_applications/${row.id}/approve`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.state === 'init' && {
        component: 'dialogFormButton',
        props: {
          label: this.$t('actions.user.reject'),
          can: 'withdrawal_applications.reject',
          value: row,
          columns: formColumnsExtend([
            {
              key: 'reject_reason',
              renderCell: {
                required: true,
              }
            }
          ], { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/withdrawal_applications/${row.id}/reject`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      let params = this.$route.query;
      if (this.miapayWalletHolderId) {
        params.wallet_holder_id_eq = this.miapayWalletHolderId;
      }
      const { data, pagination } = await this.$request.get('/withdrawal_applications', { params });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/withdrawal_applications/${this.$route.params.id}`);
      return { data };
    }

    if (type === 'new') {
      return {
        data: {}
      }
    }
  }
}

export const route = [
  {
    path: '/withdrawal_applications',
    name: 'withdrawal_applications.index',
    component: WithdrawalApplications,
    props: {
      type: 'index',
    }
  },
  {
    path: '/withdrawal_applications/new',
    name: 'withdrawal_applications.new',
    component: WithdrawalApplications,
    props: {
      type: 'new',
    }
  },
  {
    path: '/withdrawal_applications/:id',
    name: 'withdrawal_applications.show',
    component: WithdrawalApplications,
    props: {
      type: 'show',
    }
  },
  {
    path: '/withdrawal_applications/:id/edit',
    name: 'withdrawal_applications.edit',
    component: WithdrawalApplications,
    props: {
      type: 'edit'
    }
  }
]
</script>
